export default "__VITE_ASSET__DYvXkkGq__"